import _defineProperty from "@babel/runtime/helpers/defineProperty";
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import CommonPropTypes from "../../../../../../common/constants/proptypes/CommonPropTypes";
import AddonDiscoveryPropTypes from "../../../../../constants/proptypes/AddonDiscoveryPropTypes";
import FacetView from "./FacetView";
export default class ConjunctiveFacet extends Component {
  constructor(...args) {
    super(...args);

    _defineProperty(this, "isSelectedValue", facetProductValue => this.props.filters.get(this.props.facet.get('key')) === facetProductValue);

    _defineProperty(this, "createNewFilters", facetProduct => this.props.filters.get(this.props.facet.get('key')) === facetProduct ? this.props.filters.delete(this.props.facet.get('key')) : this.props.filters.set(this.props.facet.get('key'), facetProduct));
  }

  render() {
    return /*#__PURE__*/React.createElement(FacetView, {
      closeOnItemSelected: true,
      createNewFilters: this.createNewFilters,
      facet: this.props.facet,
      facetBar: this.props.facetBar,
      filters: this.props.filters,
      hiddenFilters: this.props.hiddenFilters,
      isSelectedValue: this.isSelectedValue,
      itemFactory: this.props.itemFactory,
      FacetComponent: this.props.FacetComponent,
      onFacetProductClick: this.props.onFacetProductClick,
      perspective: this.props.perspective,
      sortingLogicForCategory: this.props.sortingLogicForCategory,
      stateChangeRequested: this.props.stateChangeRequested
    });
  }

}

_defineProperty(ConjunctiveFacet, "propTypes", {
  facetBar: PropTypes.oneOf(['top', 'side']),
  facet: AddonDiscoveryPropTypes.processedFacet.isRequired,
  filters: CommonPropTypes.filters.isRequired,
  hiddenFilters: AddonDiscoveryPropTypes.hiddenFilters.isRequired,
  itemFactory: PropTypes.func.isRequired,
  FacetComponent: PropTypes.func.isRequired,
  onFacetProductClick: PropTypes.func,
  perspective: AddonDiscoveryPropTypes.perspective.isRequired,
  sortingLogicForCategory: PropTypes.string,
  stateChangeRequested: PropTypes.func.isRequired
});